<script lang="ts" setup>
import AppState, { resetCalendarEditValidationData } from '@/states/app'
import { watch } from 'vue'
import AdvancedCalendarSetup from './AdvancedCalendarSetup.vue'
import ArchivedServices from './ArchivedServices.vue'
import NewCalendarSettings from './NewCalendarSettings.vue'
import ServiceMenuSetup from './ServiceMenuSetup.vue'

watch(() => AppState.queryParams,
  () => {
    const calendarId = AppState.queryParams?.calendarId ?? AppState.queryParams?.calendar_id
    if (calendarId && typeof calendarId === 'string' && calendarId.trim()) {
      AppState.selectedCalendarId = calendarId.trim()
      resetCalendarEditValidationData()
      AppState.showAdvancedCalendarSettings = true
    } else {
      AppState.selectedCalendarId = ''
      AppState.showAdvancedCalendarSettings = false
    }
  },
  { immediate: true }
)
</script>

<template>
  <div class="calendarSettingsWizardContainer">
    <div v-if="AppState.showAdvancedCalendarSettings">
      <AdvancedCalendarSetup />
    </div>
    <div v-else-if="AppState.showAdvancedServiceMenuSettings">
      <ServiceMenuSetup />
    </div>
    <div v-else>
      <ArchivedServices v-if="AppState.selectedSettingsTab === 'archived'" />
      <NewCalendarSettings v-else />
    </div>
  </div>
</template>

<style scoped>
.calendarSettingsWizardContainer {
  font-family: 'Inter' !important;
}
</style>
